/**
 * Current Terms & Conditions version identifier (#717).
 *
 * Must match `TermsVersion.CURRENT` on the backend
 * (ai-recruitment-backend/.../service/signup/TermsVersion.java) and the
 * "Effective date" shown on the public /terms page. Registration submits
 * this value; the backend rejects any signup that doesn't reference it.
 */
export const CURRENT_TERMS_VERSION = '2026-01-14';
